import { scrollToHash } from "../lib/api";

const STYLES = {
    light: "border-white/40 text-white hover:bg-[#D60024] hover:border-[#D60024]",
    dark: "border-black/40 text-black hover:bg-[#D60024] hover:border-[#D60024] hover:text-white",
    solid: "bg-[#D60024] border-[#D60024] text-white hover:bg-black hover:border-black",
    black: "bg-[#0A0A0A] border-[#0A0A0A] text-white hover:bg-transparent hover:text-black",
};

export function PlusButton({ href = "#", label, variant = "light", testId, className = "" }) {
    const handle = (e) => {
        if (href.startsWith("#")) {
            e.preventDefault();
            scrollToHash(href);
        }
    };
    const external = /^https?:/.test(href);
    return (
        <a
            data-testid={testId}
            href={href}
            onClick={handle}
            {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            className={`group inline-flex items-center gap-3 border px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.25em] transition-colors duration-300 ${STYLES[variant]} ${className}`}
        >
            {label}
            <span className="inline-block font-display text-xl leading-none transition-transform duration-300 group-hover:rotate-45" aria-hidden="true">+</span>
        </a>
    );
}
